import React, { useState, useEffect, useContext, createContext } from 'react';


import { DataContext } from '../../../init/getData';
import { PosCartContext } from '../../../init/posCartData';

import { Modal, Col, Form, Row, DropdownButton, Dropdown, InputGroup, Card } from 'react-bootstrap';
import { Button } from 'antd';

import toast from 'react-hot-toast';
import KeyPad from '../../../components/keyPad/keyPad';

export const selectedMissionContext = createContext();

function DetailsModel(props) {

  const { api, showModal, toggleModal, title, selectedProducts, selectedTab, selectedIndex } = props;
  const { tabData, setCart } = useContext(PosCartContext);

  const { settingData, posDetailsData } = useContext(DataContext);


  const cart = tabData[selectedTab].cart;
  const selectedProduct = cart[selectedIndex];


  const [loadingEffect, setLoadingEffect] = useState(false);
  const [inputValue, setInputValue] = useState("");

  useEffect(() => {
    setInputValue(selectedProduct?.details);
  }, [showModal]);


  const addDetails = () => {

    let updatedCart = [...cart]

    
    updatedCart[selectedIndex] = {
      ...updatedCart[selectedIndex],  
          details: inputValue || '',
        
    }


    setCart(updatedCart, selectedTab);
    toggleModal();
  };




  const addDetailsBox = (details) => {
    setInputValue((prevValue) => prevValue + ' ' + details);
  };


  return (
    <Modal show={showModal} onHide={toggleModal} backdrop='static' className='Delete_modal'>
      <Modal.Header style={{ background: "#1d7790" }} closeButton>
        <Modal.Title className="arabicText" style={{ color: "white" }}>{title}</Modal.Title>
      </Modal.Header>
      <Modal.Body className="arabicText">

        <Row className='mb-5'>
          <div
            style={{
              display: 'grid',  // Use CSS Grid
              gridTemplateColumns: 'repeat(3, 1fr)', // 4 equal-width columns
              gridAutoRows: 'minmax(80px, 80px)', // Ensures rows adjust based on content, but stay at least 150px tall
              gap: '5px',  // Space between items (adjust as needed)
            }}
          >

            {posDetailsData?.map((item, index) => (
              <div
                className="card"
                key={index}
                onClick={() => addDetailsBox(item?.details)}
                style={{
                  height: '80px',
                  width: '95%',
                  textAlign: 'center',
                  marginTop: 5,
                  padding: '10px',  // Added some padding inside each item for spacing
                  display: 'flex',
                  justifyContent: 'center',
                  alignItems: 'center',
                  backgroundColor: '#b7e3f2',
                  cursor: 'pointer',
                  fontWeight: '500',
                  boxSizing: 'border-box',  // Ensure padding and margins are accounted for within the width
                }}
              >
                {item?.details?.length > 30
                  ? `${item.details.slice(0, 30)}...`
                  : item.details}
              </div>
            ))}

          </div>
        </Row>


        <Row className='mb-3'>
          <Col>
            <Form.Control as="textarea" value={inputValue} onChange={e => setInputValue(e.target.value)} autoFocus rows={3} />
          </Col>
        </Row>



      </Modal.Body>
      <Modal.Footer>
        <div>
          <Button type="primary" size="large" loading={loadingEffect} onClick={addDetails}
            style={{ marginLeft: '10px', backgroundColor: '#1d7790' }} danger>Done</Button>
        </div>
      </Modal.Footer>
    </Modal>
  );
}

export default DetailsModel;
